import { View, Text, StyleSheet, Linking, Image } from "react-native";
import { Colors, PRIVACY_POLICY } from "@/constants";
import PrimaryButton from "@/ui/PrimaryButton";
import { useTranslation } from "react-i18next";
import { ms } from "@/ui/moderateScale";
import { useAuth } from "@/models/useAuth";
import { getPlatform } from "@/models/platform";
import { useRouter } from "@/_router";
import { getBasePath } from "@/models/utils";
import { useUISlice } from "@/models/useUISlice";
import { useUserSlice } from "@/models/useUserSlice";

export default function AuthScreen() {
  const { t } = useTranslation();
  const router = useRouter();

  const onSignInComplete = () => {
    router.replace(`${getBasePath()}/home`);
    setTimeout(() => {
      if (!useUserSlice.getState().isSubscribed) {
        useUISlice.getState().setPaywallVisible(true);
      }
    }, 500);
  };

  return (
    <View style={StyleSheet.flatten([styles.container])}>
      <View style={{ flex: 1, justifyContent: "space-between" }}>
        <View style={styles.topContent}>
          <Image
            source={{ uri: "/icon.png" }}
            style={{
              width: ms(48),
              height: ms(48),
              marginBottom: ms(16),
              borderWidth: 1,
              borderColor: Colors.borderColor,
              borderRadius: ms(16),
            }}
          />

          <Text style={styles.tagline}>
            {t("onboarding.tagline")}
            {"\n"}
            <Text style={{ color: Colors.accent }}>
              {t("onboarding.taglineColored")}
            </Text>
          </Text>
        </View>

        <View style={styles.bottomContent}>
          <View style={styles.buttonContainer}>
            {getPlatform() === "ios" && (
              <PrimaryButton
                text={t("onboarding.signInWithApple")}
                onPress={() =>
                  useAuth.signInWithApple({
                    callback: (authToken) => {
                      useAuth.onAuthSuccess(authToken, onSignInComplete);
                    },
                  })
                }
                icon="apple"
                style={{ backgroundColor: Colors.black }}
                iconStyle={{
                  tintColor: Colors.white,
                  width: ms(18),
                  height: ms(18),
                  marginTop: 0,
                }}
              />
            )}

            <PrimaryButton
              text={t("onboarding.signInWithGoogle")}
              onPress={() =>
                useAuth.signInWithGoogle({
                  callback: (authToken) => {
                    useAuth.onAuthSuccess(authToken, onSignInComplete);
                  },
                })
              }
              icon="google"
              style={{
                backgroundColor: Colors.white,
                borderWidth: 1,
                borderColor: Colors.borderColor,
              }}
              textStyle={{ color: Colors.text }}
              iconStyle={{
                tintColor: undefined,
                width: ms(18),
                height: ms(18),
                marginTop: ms(1),
              }}
            />

            <PrimaryButton
              text={t("onboarding.signInWithEmail")}
              onPress={() =>
                useAuth.signIn({
                  callback: (authToken) => {
                    useAuth.onAuthSuccess(authToken, onSignInComplete);
                  },
                })
              }
              icon="email"
              style={{
                backgroundColor: Colors.white,
                borderWidth: 1,
                borderColor: Colors.borderColor,
              }}
              textStyle={{ color: Colors.text }}
              iconStyle={{
                tintColor: undefined,
                width: ms(18),
                height: ms(18),
                marginTop: ms(1),
              }}
            />
          </View>

          {/* Privacy Policy */}
          <Text style={styles.privacyText}>
            {t("onboarding.termsPrefix")}{" "}
            <Text
              style={styles.privacyLink}
              onPress={() => Linking.openURL(PRIVACY_POLICY)}
            >
              {t("onboarding.privacyPolicyText")}
            </Text>
            {t("onboarding.termsSuffix")}
          </Text>
        </View>
      </View>
    </View>
  );
}

const styles = StyleSheet.create({
  container: {
    flex: 1,
    width: "100%",
    height: "100%",
    backgroundColor: Colors.bg,
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    position: "absolute",
  },
  topContent: {
    padding: ms(16),
    flex: 1,
    alignItems: "center",
    marginTop: ms(64),
  },
  bottomContent: {
    marginBottom: ms(40),
  },
  tagline: {
    fontSize: ms(20),
    lineHeight: ms(28),
    fontWeight: "700",
    color: Colors.text,
    textAlign: "center",
    maxWidth: "80%",
  },
  buttonContainer: {
    width: "100%",
    paddingHorizontal: ms(16),
    gap: ms(12),
    alignSelf: "center",
  },
  privacyText: {
    marginTop: ms(8),
    color: Colors.subtitle,
    fontWeight: "300",
    fontSize: ms(12),
    textAlign: "center",
  },
  privacyLink: {
    color: Colors.accent,
    textDecorationLine: "underline",
  },
});
